module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/washer-ad519809dd2963eea4cb94e2802d1d06.svg";